import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@companydotcom/potion';
import { FontAwesomeIcon as FAwesomeIcon, } from '@fortawesome/react-fontawesome';
// @ts-ignore
export const FontAwesomeIcon = props => _jsx(Icon, Object.assign({ as: FAwesomeIcon }, props), void 0);
